module.exports = __webpack_public_path__ + "static/pageUnderConstruction-0090fd2edb0787fe8913cfc5a09f4340.svg";